import React from 'react'
import { Input } from 'components/ui'

const NumberInput = (props) => {
    return <Input {...props} value={props.field.value} />
}

export default NumberInput
